import React, { Component } from "react";
import ReactTable from "react-table";
import axios from "axios";
import { Switch, Modal, Button, message } from "antd";
import { Button as ReactButton } from "reactstrap";
import CustomDrawer from "../components/CustomDrawer";
import DropdownBtn from "../components/DropdownBtn";
import { serviceValidator } from "../utils/serviceValidator";

class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [],
      current_uuid: "",
      openAlert: false,
      openModal: false,
      isNewService: false,
      service: { svg: "", title: "", id: "", status: false },
      formErrors: {},
    };
    this.handleEditForm = this.handleEditForm.bind(this);
    this.getAllServices = this.getAllServices.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCancelForm = this.handleCancelForm.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleToggleStatus = this.handleToggleStatus.bind(this);
    this.handleDeleteService = this.handleDeleteService.bind(this);
  }

  componentDidMount() {
    this.getAllServices();
  }
  getAllServices() {
    axios.post("https://dev.nadu.xyz/dev/admin/getServices").then((res) => {
      if (typeof res !== "undefined") {
        this.setState({
          services: res.data.map((option) => {
            return {
              uuid: option.uuid,
              status: (
                <Switch
                  checked={option.status}
                  onChange={() => this.handleToggleStatus(option.uuid)}
                />
              ),
              id: option.id,
              title: option.title,
              svg: (
                <div
                  style={{
                    width: "40px",
                    height: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: decodeURIComponent(option.svg)
                      .replace(/\\\"/g, '"')
                      .replace("<svg ", '<svg width="100%" height="100%" '),
                  }}
                />
              ),
              actions: (
                <DropdownBtn
                  section={option}
                  handleEditSection={() =>
                    this.handleOpenModal(false, option.uuid)
                  }
                  handleDelete={() =>
                    this.setState({
                      openAlert: true,
                      current_uuid: option.uuid,
                    })
                  }
                />
              ),
            };
          }),
        });
      }
    });
  }
  handleOpenModal(isNew = false, uuid) {
    if (isNew) {
      this.setState({ openModal: true, isNewService: isNew });
    } else {
      const selectedOption = this.state.services.find(
        (elem) => elem.uuid === uuid
      );
      this.setState({
        openModal: true,
        isNewRate: false,
        service: {
          uuid: selectedOption.uuid,
          svg: selectedOption.svg,
          title: selectedOption.title,
          id: selectedOption.id,
          status: selectedOption.status.props.checked,
        },
      });
    }
  }
  handleCancelForm() {
    this.setState({
      openModal: false,
      isNewService: false,
      service: { svg: "", title: "", id: "", status: false },
    });
  }
  validateAndSetErrors() {
    const { service } = this.state;
    const errors = serviceValidator(service);
    this.setState({ formErrors: errors });
  }
  handleInputChange(event) {
    if (typeof event === "boolean") {
      this.setState({ service: { ...this.state.service, status: event } }, () =>
        this.validateAndSetErrors()
      );
    } else {
      const { name, value } = event.target;
      this.setState({ service: { ...this.state.service, [name]: value } }, () =>
        this.validateAndSetErrors()
      );
    }
  }
  handleFormSubmit() {
    axios
      .post("https://dev.nadu.xyz/dev/admin/createService", {
        params: this.state.service,
      })
      .then((res) => {
        if (res.data.ok) {
          message.success(res.data.message);
          this.getAllServices();
          this.setState({
            service: { svg: "", title: "", id: "", status: false },
            openModal: false,
            isNewService: false,
          });
        } else {
          message.error(res.data.error);
        }
      })
      .catch(() => message.error("Hubo un error al crear el servicio."));
  }
  handleEditForm() {
    const formattedRes = {
      node_id: this.state.service.uuid,
      fields: {
        id: this.state.service.id,
        title: this.state.service.title,
        status: this.state.service.status,
      },
    };
    axios
      .post("https://dev.nadu.xyz/dev/admin/updateService", {
        params: formattedRes,
      })
      .then((res) => {
        if (res.data.ok) {
          message.success("Servicio editado correctamente.");
          this.getAllServices();
          this.setState({
            service: { svg: "", title: "", id: "", status: false },
            openModal: false,
            isNewService: false,
          });
        } else {
          message.error(res.data.error);
        }
      })
      .catch((error) => message.error("Hubo un error al editar el servicio."));
  }
  handleDeleteService(uuid) {
    axios
      .post("https://dev.nadu.xyz/dev/admin/deleteService", { params: uuid })
      .then((response) => {
        message.success("Servicio eliminado correctamente.");
        this.getAllServices();
      })
      .catch((error) =>
        message.error("Hubo un error al eliminar el servicio.")
      );
  }
  handleToggleStatus(uuid) {
    axios
      .post("https://dev.nadu.xyz/dev/admin/serviceStatus", { params: uuid })
      .then((res) => {
        if (res.data.ok) {
          message.success(res.data.message);
          const allServices = [...this.state.services].map((service) => {
            if (
              service.uuid === uuid &&
              res.data.newStatus === !service.status.props.checked
            ) {
              const newObj = {
                ...service,
                status: {
                  ...service.status,
                  props: {
                    ...service.status.props,
                    checked: res.data.newStatus,
                  },
                },
              };
              return newObj;
            } else return service;
          });

          this.setState({
            services: allServices,
          });
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) =>
        message.error("Hubo un error al actualizar el estado.")
      );
  }
  render() {
    return (
      <div>
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            justifyContent: "center",
          }}
        >
          <ReactButton
            style={{ width: "fit-content" }}
            onClick={() => this.handleOpenModal(true)}
          >
            Añadir Servicio
          </ReactButton>
          <ReactTable
            style={{ width: "100%" }}
            columns={[
              {
                Header: "Icono",
                accessor: "svg",
                sortable: false,
                filterable: false,
              },
              {
                Header: "Titulo",
                accessor: "title",
              },
              {
                Header: "Status",
                accessor: "status",
                filterable: false,
              },
              {
                Header: "Actions",
                accessor: "actions",
                sortable: false,
                filterable: false,
              },
            ]}
            data={this.state.services}
            filterable
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </div>
        <CustomDrawer
          isNewService={this.state.isNewService}
          openModal={this.state.openModal}
          service={this.state.service}
          formErrors={this.state.formErrors}
          handleCancelForm={this.handleCancelForm}
          handleInputChange={this.handleInputChange}
          handleFormSubmit={this.handleFormSubmit}
          handleEditForm={this.handleEditForm}
        />
        <Modal
          open={this.state.openAlert}
          title="Eliminar elemento"
          closeIcon={false}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "15px",
          }}
          footer={() => (
            <div style={{ display: "flex", gap: "6px" }}>
              <Button onClick={() => this.setState({ openAlert: false })}>
                Cancelar
              </Button>
              <Button
                onClick={() => {
                  this.handleDeleteService(this.state.current_uuid);
                  this.setState({ openAlert: false });
                }}
                type="primary"
                danger={true}
              >
                Eliminar
              </Button>
            </div>
          )}
        >
          ¿Deseas eliminar el elemento?
        </Modal>
      </div>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/views/Configurator/Tabs/Services.jsx